import { useLocation } from 'react-router-dom';
import ProfileSkeleton from 'modules/components/common/loading/profile-skeleton';
import NotifSkeleton from 'modules/components/common/loading/notif-skeleton';
import ScanLoading from 'modules/components/common/loading/scan-loading';
import { PatientReportLoading } from 'modules/report/components/report-components/loading/report-loadings';
import { PatientListLoading } from 'modules/patient-list/components/list-skeleton-loading';
import { DashboardLoading } from 'modules/home/components/dashboard-loading';

const routesObject = [
  { route: '/app/scan', component: <ScanLoading /> },
  { route: '/app/home', component: <DashboardLoading /> },
  {
    route: '/app/list',
    component: <PatientListLoading />
  },
  { route: '/app/report', component: <PatientReportLoading /> },
  {
    route: '/app/profile',
    component: (
      <div style={{ margin: '0 12px 0' }}>
        <ProfileSkeleton />
      </div>
    )
  }
  // { route: '/app/notification', component: <NotifSkeleton /> }
];

function findSpeceficLoading(pathname) {
  const result = routesObject.filter((item) => item.route === pathname);
  return result[0];
}

const useReturnFallback = () => {
  const { pathname } = useLocation();
  const loading = findSpeceficLoading(pathname);
  return loading?.route ? loading?.component : '';
};

export { useReturnFallback };
